import React from 'react';
import { ButtonProps, Button as GridKitButton, Loader } from 'gd-design-library';
import styles from './Button.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);
const CN = 'button';
const buttonLoadingClassName = `${CN}--loading`;
const loaderClassName = `${CN}__loader`;

interface CustomButtonProps extends ButtonProps {
  className?: string;
  loading?: boolean;
}

export const Button: React.FC<CustomButtonProps> = ({
  children,
  className,
  variant = 'primary',
  loading = false,
  disabled,
  iconStart,
  iconEnd,
  ...rest
}) => (
  <GridKitButton
    className={ cx(CN, { [buttonLoadingClassName]: loading }, className) }
    variant={ variant }
    disabled={ disabled || loading }
    iconStart={ iconStart }
    iconEnd={ iconEnd }
    { ...rest }
  >
    {children}
    {loading && <Loader name='circle' size='sm' variant='inline' withWrapper={ false } className={ cx(loaderClassName) } />}
  </GridKitButton>
);
